<template>
    <el-drawer
        :title="formData.ulr ? '编辑TDC短链' : '创建TDC短链'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                size="medium"
            >
                <el-form-item label="原始链接:" prop="longUrl">
                    <el-input v-model="formData.longUrl" placeholder="请输入原始链接" maxlength="100" show-word-limit></el-input>
                </el-form-item>                
                <el-form-item prop="remark" label="备注:">
                    <el-input v-model="formData.remark" placeholder="请输入备注" maxlength="100" show-word-limit></el-input>
                </el-form-item>
				<el-form-item prop="tagList" label="标签:">
				    <el-input
				        show-word-limit
				        type="textarea"
				        v-model="formData.tagList"
				        placeholder="请填写标签"
				        :maxlength="1000"
				        :rows="5"
				    ></el-input>
					<small>支持填写多个标签，标签之间用<span class="color-danger">英文逗号</span>分隔</small>
				</el-form-item>
                
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认</el-button
            >
        </div>
    </el-drawer>
</template>
<script>
const defaultData = {
    remark: "",
    longUrl: "",
	tagList:""
}
export default {
    
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            dataLoading: false,
            formData:{
                ...defaultData
            },            
            rules:{
                longUrl:[{ required: true, message: "请填写原始链接" }]
            },
        }
    },
    methods:{
        close(){
            this.$refs.formData.resetFields();
            this.drawerShow = false;
            this.formData = {
                ...defaultData
            }
        },
        show(data){
            if( data ){
                this.formData = {
                    ...data,
					longUrl: data.ulr ? data.ulr : '',
                };
            }
            this.drawerShow = true;
        },
        
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/shortUrl/save',
                        data: {...this.formData},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>